'use strict';

const $ = require('jquery');
require('magnific-popup');
var moment = require('moment');
// const filter = require('lodash/filter');
// const find = require('lodash/find');
// const uniqBy = require('lodash/uniqBy');
// const orderBy = require('lodash/orderBy');
const isEqual = require('lodash/isEqual');
// const map = require('lodash/map');
// const isEmpty = require('lodash/isEmpty');

// const FuseJS = require('fuse.js');

function controller($scope, $timeout, $attrs, $window, $location, plannerService) {
    let vm = this;

    // All data
    let allShows = {};
    let allMonths = {};
    let updating = true;

    // am we loading?
    vm.loading = true;

    // currently options in dropdowns
    vm.options = {
        shows: [],
        months: [],
    }

    // single currently selected item
    vm.selected = {
        show: 0,
        month: 'Any Month',
    };

    vm.init = function () {
        plannerService.getPerformancesBySeason().then(response => {
            const shows = [{
                id: 0,
                title: 'Any Show',
                disabled: false,
            }];

            const months = [{
                title: 'Any Month',
                disabled: false,
            }];

            for (let show of response) {

                shows.push({
                    id: show.id,
                    title: show.title,
                    disabled: false,
                });

                if (show.id in allShows === false) {
                    allShows[show.id] = [];
                }

                for (let month of show.availableMonths) {
                    if (month in allMonths === false) {
                        allMonths[month] = [];
                    }

                    allShows[show.id].push(month);
                    allMonths[month].push(show.id);

                    if (months.find(x => x.title === month)) {
                        continue;
                    }

                    months.push({
                        title: month,
                        disabled: false,
                    });
                }
            }

            vm.options.shows = shows;
            vm.options.months = months;

            $scope.$watchCollection(() => vm.selected, update);
        }, e => {
            console.log(e);
        }).catch(e => {
            console.log(e);
        }).finally(function () {
            updating = false;
            vm.loading = false;
        });
    }

    function update(current, previous) {
        if (updating || isEqual(current, previous)) {
            return false;
        }

        updating = true;


        if (current.show !== previous.show) {
            for (let month of vm.options.months) {
                month.disabled = false;
                if (month.title !== 'Any Month' && current.show && current.show !== 0) {
                    month.disabled = allShows[current.show].indexOf(month.title) === -1;
                }
            };
        }

        if (current.month !== previous.month) {
            for (let show of vm.options.shows) {
                show.disabled = false;

                if (show.id !== 0 && current.month && current.month !== 'Any Month') {
                    show.disabled = allMonths[current.month].indexOf(show.id) === -1;
                }
            };
        }

        updating = false;
    }

    vm.proceed = function() {
        let show = vm.selected.show;
        let month = vm.selected.month;

        let params = new URLSearchParams();

        if (show !== 0) {
            params.set('production', show);
        }

        if (month !== 'Any Month') {
            if(month == 'Next 30 days') {
                let m = moment();
                let thirtyStart = m.clone();
                let thirtyEnd = m.clone().days(30);
                params.set('start', thirtyStart);
                params.set('end', thirtyEnd);
            } else {
                const regex = /(^\w+) (\d+)$/.exec(month);
                let m;
                if (regex) {
                    m = moment().month(regex[1]).year(regex[2]);
                } else {
                    m = moment().month(month);
                }
                let start = m.clone().startOf('month');
                let end = m.clone().endOf('month');
                params.set('start', start);
                params.set('end', end);
            }
        }

        window.location.href = $attrs.redirectUrl + '?' + params.toString();
    }

    return vm;
}

module.exports = [
    '$scope',
    '$timeout',
    '$attrs',
    '$window',
    '$location',
    'plannerService',
    controller
];



// WEBPACK FOOTER //
// ./widgets/controllers/TicketFinderNew.js